export const LEGACY_OPERATIONS = [
  'clients.create', 'clients.edit', 'clients.renew', 'clients.toggle',
  'clients.disconnect', 'clients.notify', 'resellers.notify',
];

export function canOperate(user, action) {
  if (!user) return false;
  if (user.role !== 'attendant') return user.role === 'admin' || user.role === 'reseller';
  if (action.startsWith('resellers.') && action !== 'resellers.notify'
    && (!user.root_admin_id || user.managed_by_reseller_id)) return false;
  const policy = user.operational_permissions;
  const actions = policy == null ? LEGACY_OPERATIONS
    : policy.version === 1 && Array.isArray(policy.actions) ? policy.actions : [];
  return actions.includes(action);
}
